// @flow
import React, { PureComponent } from "react";
import classNames from "classnames";

type Props = {
  height: number,
  width: number,
  className: any
};

class Youtube extends PureComponent<Props> {
  render() {
    const { height, width, className } = this.props;
    const classes = classNames("icone", className);

    return (
      <svg className={classes} height={height} width={width} viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">        
        <path d="M20.7228 17.446H3.27681C1.67759 17.446 0.369141 16.1376 0.369141 14.5383V2.90767C0.369141 1.30845 1.67759 0 3.27681 0H20.7228C22.322 0 23.6305 1.30845 23.6305 2.90767V14.5383C23.6305 16.1376 22.322 17.446 20.7228 17.446ZM22.1767 14.5383V2.90767C22.1767 2.10443 21.5261 1.45383 20.7228 1.45383H3.27681C2.47357 1.45383 1.82298 2.10443 1.82298 2.90767V14.5383C1.82298 15.3416 2.47357 15.9922 3.27681 15.9922H20.7228C21.5261 15.9922 22.1767 15.3416 22.1767 14.5383ZM14.1806 8.72301L9.81907 5.81534V11.6307L14.1806 8.72301Z" fill="black"/>
      </svg>
    );
  }
}

export default Youtube;
